import React, {useState} from 'react';
import styles from "./Paginator.module.css";

let Paginator = ({totalItemsCount, pageSize, currentPage, onPageChanged, portionSize = 10}) => {

	let pagesCount = Math.ceil(totalItemsCount / pageSize);

	let pages = [];
	for (let i = 1; i <= pagesCount; i++) {
		pages.push(i);
	}

	let portionCount = Math.ceil(pagesCount / portionSize);
	let [portionNumber, setPortionNumber] = useState(1);
	let leftPortionPageNumber = (portionNumber - 1) * portionSize + 1;
	let rightPortionPageNumber = portionNumber * portionSize;

	// return <div className={styles.pagination} style={{ height: "180px"}}>
	// 		{pages.map((p, index) => {
	// 			return <span key={index} className={currentPage === p ? (styles.selectedPage + " " + styles.pageNumber) : styles.pageNumber}
	// 									 onClick={(e) => {
	// 										 onPageChanged(p);
	// 									 }}> {p}
	// 						</span>
	// 		})}
	// </div>

	return <div className={styles.pagination}>
		{portionNumber > 1 &&
			<button className={styles.paginationNavButtun} onClick={() => {
				setPortionNumber(portionNumber - 1)
			}}>PREV</button>}

		{pages
			.filter(p => p >= leftPortionPageNumber && p <= rightPortionPageNumber)
			.map((p) => {
				return <span className={ (currentPage === p ? styles.selectedPage : '') + ' ' + styles.pageNumber}
										 key={p}
										 onClick={(e) => {
											 onPageChanged(p);
										 }}>{p}</span>
			})}

		{portionCount > portionNumber &&
			<button className={styles.paginationNavButtun} onClick={() => {
				setPortionNumber(portionNumber + 1)
			}}>NEXT</button>}
	</div>
};

export default Paginator;